import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PrimeReactProvider } from 'primereact/api'

import { LocalizationProvider } from '../common/components/localization-provider'
import { ThemeProvider } from '../common/components/theme-provider'
import { initAuthChangeListener } from '../common/utils/broadcastChannel'
import { ToastProvider } from '../common/uikit/ToastProvider'
import { ConfirmDialog } from '../common/uikit/ConfirmDialog'

import { store } from './redux/store'
import App from './App'

initAuthChangeListener()

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <ThemeProvider>
        <Suspense fallback={<div />}>
            <LocalizationProvider>
                <Provider store={store}>
                    <PrimeReactProvider>
                        <ToastProvider>
                            <BrowserRouter basename="userapp">
                                <App />
                                <ConfirmDialog />
                            </BrowserRouter>
                        </ToastProvider>
                    </PrimeReactProvider>
                </Provider>
            </LocalizationProvider>
        </Suspense>
    </ThemeProvider>
)
